import md5 from 'md5';
import * as cookieHelper from './cookieHelper';

const CHATBOT_EMBED_URL = 'https://encyc.ziondaily.com/chatbot/embed.php';
const CHATBOT_AUTH_SECRET = 'YPFYQiNhf5KOYrEifAZQwvCj';

export const isUserLoggedIn = () => {
  const cookies = cookieHelper.getCookie();
  if (!cookies) {
    return false;
  }

  const mid = cookies.zd_mid;
  const token = cookies.zd_token;
  const hasMid = Boolean(mid) && mid !== '' && String(mid) !== '0';
  const hasToken = Boolean(token) && token !== '' && String(token) !== '0';

  return hasMid && hasToken;
};

// Session flag from signin_session_token / reload_session (true|false).
// Prefer cookie; also accepts boolean-like values from parsed session payload.
export const isAiChatEnabled = (sessionPayload) => {
  const cookies = cookieHelper.getCookie() || {};
  const flag = sessionPayload && sessionPayload.zd_aichat !== undefined
    ? sessionPayload.zd_aichat
    : cookies.zd_aichat;

  if (flag === undefined || flag === null) {
    return false;
  }

  if (typeof flag === 'boolean') {
    return flag;
  }

  const normalized = String(flag).trim().toLowerCase();
  return normalized === 'true' || normalized === '1' || normalized === 'yes';
};

export const buildChatbotEmbedUrl = (userId, userName) => {
  const mid = userId ?? '';
  const t = Math.floor(Date.now() / 1000);
  const hash = md5(`${mid}${t}${CHATBOT_AUTH_SECRET}`);

  const params = new URLSearchParams({
    mid: String(mid),
    t: String(t),
    hash,
    name: String(userName ?? ''),
  });

  return `${CHATBOT_EMBED_URL}?${params.toString()}`;
};
